import {AREA_UNITS, type AreaUnit} from '@src/constants/measureUnits.ts';
import {CONVERSION_MAP} from '@src/utils/unitConversions.ts';
import formatNumber from './formatNumber.ts';

export const formatArea = (
  squareMeters: number,
  unit?: AreaUnit,
  options = {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  },
) => {
  const conversionFn =
    CONVERSION_MAP.area.fromSqm[(unit ?? AREA_UNITS.metric.m2) as string];
  return conversionFn ? formatNumber(conversionFn(squareMeters), options) : '';
};

export default formatArea;
